import { render, staticRenderFns } from "./ChartBarV2.vue?vue&type=template&id=763b2222&scoped=true"
import script from "./ChartBarV2.vue?vue&type=script&lang=js"
export * from "./ChartBarV2.vue?vue&type=script&lang=js"
import style0 from "./ChartBarV2.vue?vue&type=style&index=0&id=763b2222&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "763b2222",
  null
  
)

export default component.exports